// LoveArt — galeria, variantes, abas, adicionar à sacola (AJAX) e sacola lateral.
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
  var money = function (cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: currency });
  };

  // ---------- sacola lateral ----------
  var drawerSection = 'cart-drawer';
  var lastFocus = null;

  function drawer() { return document.querySelector('[data-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-close-cart]');
    if (close) close.focus();
    return true;
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function renderDrawer(html, keepOpen) {
    var holder = document.getElementById('shopify-section-' + drawerSection);
    if (!holder || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-drawer]');
    var current = drawer();
    if (!fresh || !current) return;
    fresh.hidden = !keepOpen;
    current.replaceWith(fresh);
    var src = fresh.querySelector('[data-cart-count-source]');
    var count = src ? parseInt(src.textContent, 10) || 0 : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshDrawer(keepOpen) {
    return fetch(root + '?sections=' + drawerSection)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data[drawerSection], keepOpen); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-cart]');
    if (opener && drawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-close-cart]') || e.target.matches('[data-drawer]')) {
      closeDrawer();
      return;
    }
    var line = e.target.closest('[data-line]');
    if (line) {
      line.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: parseInt(line.dataset.lineQty, 10), sections: drawerSection })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) renderDrawer(data.sections[drawerSection], true);
          else refreshDrawer(true);
        })
        .catch(function () { line.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && !d.hidden) closeDrawer();
  });

  // Adicionar à sacola sem sair da página
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form || !drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.adding || 'Adicionando...'; }
    var body = new FormData(form);
    body.append('sections', drawerSection);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'erro');
        if (res.data.sections) renderDrawer(res.data.sections[drawerSection], true);
        else return refreshDrawer(true);
      })
      .then(function () { openDrawer(); })
      .catch(function (err) { window.alert(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // ---------- abas de produtos ----------
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  // ---------- galeria do produto ----------
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.gallery__main img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  // ---------- quantidade + / - ----------
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
      });
    });
  });

  // ---------- variantes na página do produto ----------
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var pix = parseInt(form.dataset.pix, 10) || 0;
    var installments = parseInt(form.dataset.installments, 10) || 0;
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('[data-add-to-cart]');
    var info = form.closest('.product__info') || document;
    var main = document.querySelector('.gallery__main img');

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = [];
      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
      });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.unavailable;
        return;
      }
      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.add : submit.dataset.soldout;

      var priceEl = info.querySelector('[data-price]');
      var compareEl = info.querySelector('[data-compare-price]');
      var pixEl = info.querySelector('[data-pix-price]');
      var instEl = info.querySelector('[data-installments]');
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      if (pixEl && pix) pixEl.innerHTML = '<b>' + money(Math.floor(variant.price * (100 - pix) / 100)) + '</b> no Pix';
      if (instEl && installments > 1) instEl.textContent = 'ou em até ' + installments + 'x de ' + money(Math.floor(variant.price / installments)) + ' sem juros';
      if (variant.featured_image && main) {
        main.src = variant.featured_image.src;
        main.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
